module.exports = __webpack_public_path__ + "5bd393883190b8a0dc13417fd7387001.pdf";